import React from 'react'
import 'rc-texty/assets/index.css';
import { getEnter } from '@/utils'
import { Button, Modal } from 'antd';
import upgradeReport1 from "@/assets/img/report-page/upgrade-report1.png";
import upgradeReport2 from "@/assets/img/report-page/upgrade-report2.png";
import upgradeReport3 from "@/assets/img/report-page/upgrade-report3.png";
import upgradeReport4 from "@/assets/img/report-page/upgrade-report4.png";
import upgradeReport5 from "@/assets/img/report-page/upgrade-report5.png";
import upgradeReport6 from "@/assets/img/report-page/upgrade-report6.png";
import upgradeReport7 from "@/assets/img/report-page/upgrade-report7.png";
import upgradeReport8 from "@/assets/img/report-page/upgrade-report8.png";
import upgradeReport9 from "@/assets/img/report-page/upgrade-report9.png";
import upgradeReport10 from "@/assets/img/report-page/upgrade-report10.png";
import upgradeReport11 from "@/assets/img/report-page/upgrade-report11.png";
import upgradeReport12 from "@/assets/img/report-page/upgrade-report12.png";
import upgradeReport13 from "@/assets/img/report-page/upgrade-report13.png";
import upgradeReport14 from "@/assets/img/report-page/upgrade-report14.png";
import upgradeReport15 from "@/assets/img/report-page/upgrade-report15.png";
import "./index.less";
const UpgradeDetailModal = (props) => {
	const { closeModal } = props || {};
  return (
		<>
			<Modal width='90vw' className="report-modal" title="企业信用报告-升级版" open footer={null} onCancel={closeModal}>
        <div className='report-content'>
					<img className='report-img' src={upgradeReport1} />
					<img className='report-img' src={upgradeReport2} />
					<img className='report-img' src={upgradeReport3} />
					<img className='report-img' src={upgradeReport4} />
					<img className='report-img' src={upgradeReport5} />
					<img className='report-img' src={upgradeReport6} />
					<img className='report-img' src={upgradeReport7} />
					<img className='report-img' src={upgradeReport8} />
					<img className='report-img' src={upgradeReport9} />
					<img className='report-img' src={upgradeReport10} />
					<img className='report-img' src={upgradeReport11} />
					<img className='report-img' src={upgradeReport12} />
					<img className='report-img' src={upgradeReport13} />
					<img className='report-img' src={upgradeReport14} />
					<img className='report-img' src={upgradeReport15} />
				</div>
				<div className='report-footer'>
					<Button onClick={closeModal}>关闭</Button>
				</div>
      </Modal>
		</>
  )
}

export default UpgradeDetailModal;
